import { useState, useEffect } from 'react';
import CommonConfig from '../../utils/constant';
import SchoolProfile from './SchoolProfile';
import TeacherProfile from './TeacherProfile';
import StudentProfile from './StudentProfile';
import ParentProfile from './ParentProfile';

const EditProfile = (props) => {
    return (
        <div className="e-teacher-dashboard">
            {CommonConfig.isOrgOwner(CommonConfig.loginData().UserRole) ? <SchoolProfile /> : CommonConfig.loginData().UserRole === 'Teacher' ? <TeacherProfile /> : CommonConfig.loginData().UserRole === 'Student' ? <StudentProfile /> : <ParentProfile/>}
        </div>
    );
};

export default EditProfile;
